import styles from "./ToggleSwitch.module.css";
import React from "react";

function ToggleSwitch({ active, onclick }) {
  return (
    <div className={`${styles.toggleSwitch} ${active ? styles.active : ""}`} onClick={onclick}>
      <span className={`${active ? styles.toggleButtonActive : styles.toggleButton}`}></span>
    </div>
  );
}

export default ToggleSwitch;
